/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Widgets.Envelopes";
        class EnvelopesWidgetTypeClass extends Widgets.WidgetTypeBaseClass {
            constructor(core, widgets, widgetName, config, layout, readyCallback = null) {
                super(core, widgets, widgetName, config, layout, readyCallback);
                this.createInstance = (config) => {
                    this._log.info("EnvelopesWidgetTypeClass.createInstance()");
                    return new EnvelopesWidgetInstanceClass(this._core, this, this._widgets, config, this._originatingLayout);
                };
                this._storeHtml = (htmlData) => {
                    this._log.info("EnvelopesWidgetTypeClass._storeHtml()");
                    EnvelopesWidgetInstanceClass.HtmlData = htmlData;
                    this._presentInstances();
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("EnvelopesWidgetTypeClass::constructor");
                if (EnvelopesWidgetInstanceClass.HtmlData != null) {
                    // make async call in order to get the instances created first
                    window.setTimeout(this._presentInstances, 0);
                }
                else {
                    core.Loader.getVersionedHTML('widgets/Envelopes/Envelopes.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
                }
            }
        }
        Widgets.EnvelopesWidgetTypeClass = EnvelopesWidgetTypeClass;
        class EnvelopesWidgetInstanceClass extends Widgets.WidgetInstanceBaseClass {
            constructor(core, type, widgets, config, layout) {
                super(core, type, widgets, config, layout);
                this._instanceSelector = null;
                this._componentContainer = null;
                this._showOptionsSpan = null;
                this._hideOptionsSpan = null;
                this._envComponent = null;
                this._addButton = null;
                this._refreshButton = null;
                this._selectNewEnvelopes = true;
                this._filterText = null;
                this._filter = null;
                this._reactToSlots = [WPTNamespace.Utilities.PRIMARY_SLOT_KEY, WPTNamespace.Utilities.RELATED_SLOT_KEY];
                this._lastReactedSlots = [];
                this.presentInstance = () => {
                    this._log.info("EnvelopesWidgetInstanceClass.presentInstance()");
                    this._container.innerHTML = EnvelopesWidgetInstanceClass.HtmlData;
                    this._prepareErrorBanner();
                    this._componentContainer = this._container.querySelector('#envelopesHolder');
                    this._addButton = this._container.querySelector('#envelopesAddButton');
                    this._refreshButton = this._container.querySelector('#envelopesReload');
                    this._showOptionsSpan = this._container.querySelector('.envelopesShowFilter');
                    this._hideOptionsSpan = this._container.querySelector('.envelopesCancelFilter');
                    this._filterText = this._container.querySelector('#envelopesFilter');
                    this._filter = this._container.querySelector('.widget__filter');
                    this._widgets.setTitle(this._config, this._container.querySelector('#envelopesWidgetTitle'), 'STR_WPT_ENVELOPES');
                    this._widgets.setCollapseState(this._config, this._instanceSelector);
                    this._widgets.addCollapseEventListener(this);
                    this._widgets.setWidgetHeight(this._config, this._container);
                    this._widgets.setSuppressBorder(this._config, this._container);
                    this._widgets.setSuppressHeading(this._config, this._container);
                    this._core.Helper.setElementTranslationAttribute(this._filterText, 'placeholder', 'STR_WPT_FILTERLIST');
                    this._core.Helper.setElementTranslationAttribute(this._filterText, 'aria-label', 'STR_WPT_FILTERLIST');
                    this._core.Helper.setElementTranslationAttribute(this._showOptionsSpan, 'title', 'STR_WPT_FILTER');
                    this._core.Helper.setElementTranslationAttribute(this._addButton, 'title', 'STR_WPT_HIDE_FILTER');
                    this._core.Helper.setElementTranslationAttribute(this._refreshButton, 'title', 'STR_WPT_REFRESH');
                    this._addButton.addEventListener('click', this._addButtonClicked);
                    this._refreshButton.addEventListener('click', this._reload);
                    this._showOptionsSpan.addEventListener('click', this._showOptions);
                    this._hideOptionsSpan.addEventListener('click', this._hideOptions);
                    this._filterText.addEventListener('keyup', this._doFilter);
                    this._container.querySelector('.envelopesClearFilter').addEventListener('click', this._clearFilter);
                    let conf = this._config;
                    if (conf.hasOwnProperty('SelectNewEnvelopes') && (conf.SelectNewEnvelopes != null))
                        this._selectNewEnvelopes = conf.SelectNewEnvelopes;
                    if (conf.hasOwnProperty("ReactToSlots") && (conf.ReactToSlots != null))
                        this._reactToSlots = conf.ReactToSlots;
                    let componentConf = { SelectNewEnvelopes: this._selectNewEnvelopes };
                    this._envComponent = new Widgets.ComponentEnvelopes(this._core, this._componentContainer, this, componentConf);
                    this._envComponent.ErrorCallback = this._callErrorHandler;
                    this._envComponent.FailCallback = this._callFailedHandler;
                    this._envComponent.EnvelopeSelectedCallBack = this._envelopeSelected;
                    this._envComponent.EnvelopeContentCallBack = this._docListReceived;
                    this._envComponent.present();
                    this._envComponent.doSearch();
                    this._doFilter();
                    this._type.instanceReady(this.getHandle());
                };
                this._callFailedHandler = (json) => {
                    this._log.info("EnvelopesWidgetInstanceClass._callFailedHandler()");
                    let response = json;
                    this.addError(response.Connection.Message);
                };
                this._callErrorHandler = (url, status, message) => {
                    this._log.info("EnvelopesWidgetInstanceClass._callErrorHandler()");
                    this.addError(message);
                };
                this._reload = () => {
                    this._log.info("EnvelopesWidgetInstanceClass._reload()");
                    this._envComponent.doSearch();
                    this._doFilter();
                };
                this._envelopeSelected = (envelope) => {
                    this._log.info("EnvelopesWidgetInstanceClass._envelopeSelected()");
                    let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.ENVELOPE_SELECTED);
                    navEvent.ActivationID = envelope.Id;
                    navEvent.PrimaryContext = envelope;
                    // Set default layout, but check if we've had an alternative requested against the instance
                    let config = this._config;
                    let targetLayoutName = "Envelopes";
                    if (config.hasOwnProperty("LaunchLayout") && config.LaunchLayout) {
                        if (config.LaunchLayout == "[[CURRENT]]")
                            targetLayoutName = this._currentLayout;
                        else
                            targetLayoutName = config.LaunchLayout;
                    }
                    // Add transfer widgets if we are moving
                    if (targetLayoutName != this._currentLayout) {
                        if (config.hasOwnProperty("ForwardOtherWidgets")) {
                            navEvent.populateTransferList(config.ForwardOtherWidgets, this._core);
                        }
                    }
                    navEvent.Layout = targetLayoutName;
                    this._core.Navigation.Details.requestActivation(navEvent);
                    if (envelope)
                        this._envComponent.getEnvelopeContent(envelope.Id);
                };
                this._docListReceived = (env) => {
                    this._log.info("EnvelopesWidgetInstanceClass._docListReceived()");
                    let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.QUERY_RESULT_DOCUMENTS);
                    navEvent.ActivationID = env.Id;
                    navEvent.PrimaryContext = env.Documents;
                    // Set default layout, but check if we've had an alternative requested against the instance
                    let config = this._config;
                    let targetLayoutName = "Envelopes";
                    if (config.hasOwnProperty("LaunchLayout") && config.LaunchLayout) {
                        if (config.LaunchLayout == "[[CURRENT]]")
                            targetLayoutName = this._currentLayout;
                        else
                            targetLayoutName = config.LaunchLayout;
                    }
                    // Add transfer widgets if we are moving
                    if (targetLayoutName != this._currentLayout) {
                        if (config.hasOwnProperty("ForwardOtherWidgets")) {
                            navEvent.populateTransferList(config.ForwardOtherWidgets, this._core);
                        }
                    }
                    navEvent.Layout = targetLayoutName;
                    this._core.Navigation.Details.requestActivation(navEvent);
                };
                this.returnedToHomepage = () => {
                    this._log.info("EnvelopesWidgetInstanceClass.returnedToHomepage()");
                    super.returnedToHomepage();
                    this._widgets.setCollapseState(this._config, this._instanceSelector);
                    this._envComponent.documentSelected(0);
                };
                this._addButtonClicked = (event) => {
                    this._log.info("EnvelopesWidgetInstanceClass._addButtonClicked()");
                    this._envComponent.addEnvelope(event);
                };
                this._showOptions = () => {
                    this._log.info("EnvelopesWidgetInstanceClass._showOptions()");
                    this._core.Functions.hideElement(this._showOptionsSpan);
                    this._core.Functions.showElement(this._hideOptionsSpan);
                    this._core.Functions.showElement(this._filter);
                    this._filterText.focus();
                };
                this._hideOptions = () => {
                    this._log.info("EnvelopesWidgetInstanceClass._hideOptions()");
                    this._core.Functions.hideElement(this._hideOptionsSpan);
                    this._core.Functions.showElement(this._showOptionsSpan);
                    this._core.Functions.hideElement(this._filter);
                    this._clearFilter();
                };
                this._clearFilter = () => {
                    this._log.info("EnvelopesWidgetInstanceClass._clearFilter()");
                    this._core.Functions.clearAndFocusInputElement(this._filterText);
                    this._doFilter();
                };
                this._doFilter = () => {
                    this._log.info("EnvelopesWidgetInstanceClass._doFilter()");
                    let filterText = this._filterText.value;
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("filtering with: " + filterText);
                    }
                    this._envComponent.filterEnvelopes(filterText);
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("EnvelopesWidgetInstanceClass::constructor");
                this._instanceSelector = config.PlaceHolder;
                this._container = document.querySelector(this._instanceSelector);
            }
            activate(context) {
                this._log.info("EnvelopesWidgetInstanceClass.activate()");
                // Don't get stuck in a loop!
                if (!this._activationSourceValid(context))
                    return;
                switch (context.ActivationType) {
                    case WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_SELECTED:
                        let slots = this._reactToSlots.filter(slot => (context.Slots.indexOf(slot) > -1));
                        if (slots.length > 0) {
                            // only remember slots we react to
                            this._lastReactedSlots = slots;
                            this._envComponent.documentSelected(context.ActivationID);
                        }
                        break;
                    case WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_DESELECTED:
                        let intersection = this._lastReactedSlots.filter(slot => (context.Slots.indexOf(slot) > -1));
                        if (intersection.length > 0) {
                            this._lastReactedSlots = [];
                            this._envComponent.documentSelected(0);
                        }
                        break;
                }
            }
        }
        EnvelopesWidgetInstanceClass.HtmlData = null;
        Widgets.EnvelopesWidgetInstanceClass = EnvelopesWidgetInstanceClass;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
